import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mbody"
};
const _hoisted_2 = {
  class: "sf"
};
const _hoisted_3 = {
  class: "sf-row"
};
const _hoisted_4 = {
  class: "sf-row"
};
const _hoisted_5 = {
  class: "sf-grid"
};
const _hoisted_6 = {
  class: "sf-row"
};
const _hoisted_7 = {
  class: "sf-row"
};
const _hoisted_8 = {
  class: "sf-row"
};
const _hoisted_9 = {
  class: "agree"
};
const _hoisted_10 = {
  class: "mfoot"
};
import { ref, computed, watch, inject } from "vue";
// import { useMediaQuery } from "@vueuse/core";
import request from "@/utils/request";
import toast from "@/utils/toast";
import { isLogin } from "@/utils/auth";
import CompetitionDialog from "@/components/CompetitionDialog.vue";
// import CompetitionMobilePopup from "@/components/CompetitionMobilePopup.vue";

export default {
  __name: 'CompetitionSignUpDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    goSection: {
      type: Function,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:modelValue", "close", "submit"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 使用计算属性处理 v-model
    const visible = computed({
      get: () => props.modelValue,
      set: value => emit("update:modelValue", value)
    });

    // const isMobile = useMediaQuery("(max-width: 767px)");

    // 注入父组件的登录触发方法
    const triggerLogin = inject("triggerLogin", () => {});
    watch(() => props.modelValue, newValue => {
      if (newValue) {
        if (!isLogin()) {
          // 如果未登录，则调用父组件的方法展示登录弹窗
          triggerLogin();
          close();
        }
      }
    });
    const defaultFormModal = () => ({
      participant_name: "",
      email: "",
      participant_type: "individual",
      mobile: "",
      experience: "",
      agree_protocol: false,
      agree_statement: true
    });
    const formModal = ref(defaultFormModal());
    const submitDisabled = computed(() => !formModal.value.agree_protocol || !formModal.value.participant_name || !formModal.value.email);
    const checkForm = () => {
      const {
        email,
        mobile
      } = formModal.value;
      // 邮箱格式不正确
      if (!/^[\w.-]+@[\w.-]+\.[\w]+$/.test(email)) {
        toast("请输入正确的邮箱格式");
        return false;
      }
      // 手机格式不正确
      if (mobile && !/^1[3456789]\d{9}$/.test(mobile)) {
        toast("请输入正确的手机格式");
        return false;
      }
      return true;
    };

    // 提交报名
    const submit = async () => {
      const isValid = checkForm();
      // console.log("submit", isValid, formModal.value);
      if (!isValid) {
        return;
      }
      try {
        const res = await request.post("/contest/user/register?contest_id=" + props.data.contest_id, formModal.value);
        if (res.code === 200) {
          toast("报名成功");
          emit("submit", res.data);
          close();
          formModal.value = defaultFormModal();
        } else {
          toast(res.msg || "报名失败");
        }
      } catch (error) {
        console.error("报名失败:", error);
        toast("报名失败，请稍后重试");
      }
    };
    const close = () => {
      emit("update:modelValue", false);
      emit("close");
    };

    // 参赛承诺书
    const showAgreement = () => {
      window.open("https://aigc-assets.mgtv.com/camp_policys/%E5%8F%82%E8%B5%9B%E6%89%BF%E8%AF%BA%E4%B9%A6.pdf");
    };

    // 版权须知与活动规则
    const showRules = () => {
      window.open("https://aigc-assets.mgtv.com/camp_policys/%E7%89%88%E6%9D%83%E9%A1%BB%E7%9F%A5%E4%B8%8E%E6%B4%BB%E5%8A%A8%E8%A7%84%E5%88%99.pdf");
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createBlock(_resolveDynamicComponent(CompetitionDialog), {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => visible.value = $event),
        title: "报名参赛",
        subtitle: __props.data.title,
        width: 600,
        onClose: close
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
          size: "large",
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: "large",
          type: "primary",
          disabled: submitDisabled.value,
          onClick: submit
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("确认报名", -1)]))]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("form", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "sf-lbl"
        }, [_createElementVNode("span", {
          class: "req"
        }, "*"), _createTextVNode(" 参赛者姓名 / 团队名称")], -1)), _withDirectives(_createElementVNode("input", {
          class: "sf-inp",
          placeholder: "请输入真实姓名或团队名称",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formModal.value.participant_name = $event)
        }, null, 512), [[_vModelText, formModal.value.participant_name]])]), _createElementVNode("div", _hoisted_4, [_cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "sf-lbl"
        }, [_createElementVNode("span", {
          class: "req"
        }, "*"), _createTextVNode(" 联系邮箱")], -1)), _withDirectives(_createElementVNode("input", {
          class: "sf-inp",
          type: "email",
          placeholder: "用于接收赛事通知",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formModal.value.email = $event)
        }, null, 512), [[_vModelText, formModal.value.email]])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "sf-lbl"
        }, "参赛形式", -1)), _withDirectives(_createElementVNode("select", {
          class: "sf-inp",
          style: {
            "cursor": "pointer"
          },
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formModal.value.participant_type = $event)
        }, [...(_cache[10] || (_cache[10] = [_createElementVNode("option", {
          value: "individual"
        }, "个人参赛", -1), _createElementVNode("option", {
          value: "team"
        }, "团队参赛（2-5人）", -1)]))], 512), [[_vModelSelect, formModal.value.participant_type]])]), _createElementVNode("div", _hoisted_7, [_cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "sf-lbl"
        }, "联系手机（选填）", -1)), _withDirectives(_createElementVNode("input", {
          class: "sf-inp",
          placeholder: "可选填",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formModal.value.mobile = $event)
        }, null, 512), [[_vModelText, formModal.value.mobile]])])]), _createElementVNode("div", _hoisted_8, [_cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "sf-lbl"
        }, "创作经验简介（选填）", -1)), _withDirectives(_createElementVNode("textarea", {
          class: "sf-ta",
          rows: "3",
          placeholder: "简单介绍你的AIGC创作经历…",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formModal.value.experience = $event)
        }, null, 512), [[_vModelText, formModal.value.experience]])]), _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "agChk",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formModal.value.agree_protocol = $event)
        }, null, 512), [[_vModelCheckbox, formModal.value.agree_protocol]]), _createElementVNode("label", {
          onClick: _cache[6] || (_cache[6] = $event => formModal.value.agree_protocol = !formModal.value.agree_protocol)
        }, [_cache[14] || (_cache[14] = _createTextVNode(" 我已阅读并同意", -1)), _createElementVNode("a", {
          style: {
            "cursor": "pointer"
          },
          onClick: _withModifiers(showAgreement, ["stop"])
        }, "《参赛承诺书》"), _cache[15] || (_cache[15] = _createTextVNode("及", -1)), _createElementVNode("a", {
          style: {
            "cursor": "pointer"
          },
          onClick: _withModifiers(showRules, ["stop"])
        }, "《版权须知与活动规则》"), _cache[16] || (_cache[16] = _createTextVNode("，确认信息真实有效 ", -1))])])])])]),
        _: 1
      }, 40, ["modelValue", "subtitle"]);
    };
  }
};